function cov_830pg6psh() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Share.tsx";
  var hash = "be373e3bb6920a2afebb67111987543934740940";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Icon/SpritesheetIcons/Share.tsx",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 45
        },
        end: {
          line: 5,
          column: 1
        }
      }
    },
    fnMap: {},
    branchMap: {},
    s: {
      "0": 0
    },
    f: {},
    b: {},
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "be373e3bb6920a2afebb67111987543934740940"
  };
  var coverage = global[gcv] || (global[gcv] = {});

  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }

  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_830pg6psh = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}

cov_830pg6psh();
var Icon = (cov_830pg6psh().s[0]++, {
  name: 'share',
  svg: "<path d=\"M13.25 5.51777L15.6161 7.88388C16.1043 8.37204 16.8957 8.37204 17.3839 7.88388C17.872 7.39572 17.872 6.60427 17.3839 6.11611L13.5547 2.28698C12.7086 1.4408 11.3481 1.40502 10.4586 2.20556L6.16379 6.07088C5.65065 6.5327 5.60905 7.32307 6.07088 7.8362C6.5327 8.34934 7.32306 8.39094 7.8362 7.92911L10.75 5.3067V15.5C10.75 16.1903 11.3096 16.75 12 16.75C12.6904 16.75 13.25 16.1903 13.25 15.5V5.51777Z\" fill=\"currentColor\"/>\n  <path d=\"M4.25 12.75H8.8V10.25H3.9C2.71259 10.25 1.75 11.2126 1.75 12.4V20.6C1.75 21.7874 2.71259 22.75 3.9 22.75H20.1C21.2874 22.75 22.25 21.7874 22.25 20.6V12.4C22.25 11.2126 21.2874 10.25 20.1 10.25H15.15V12.75H19.75V20.25H4.25V12.75Z\" fill=\"currentColor\"/>"
});
export default Icon;